import { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Stack from '@mui/material/Stack';
import { Title, Textarea } from 'components';

import styled from 'shared/utils/styled';

import { useStyles, CloseButton, SaveButton } from '../style';

const StyledTitle = styled(Title)(() => ({
  margin: 0,
  fontSize: 21,
}));

type ExpandedFormProps = {
  value: string;
  label: string;
  disabled?: boolean;
  placeholder?: string;
  onChange: (value: string) => void;
  onClose: () => void;
};

const ExpandedForm = ({
  value: defaultValue,
  onChange,
  label,
  onClose,
  disabled,
  placeholder,
}: ExpandedFormProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [value, setValue] = useState(defaultValue);

  const handleChangeValue = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = event.target;

    setValue(value);
  };

  const handleAcceptValue = () => {
    onChange(value);
    onClose();
  };

  return (
    <Stack flex={1} spacing={2}>
      <StyledTitle>{label}</StyledTitle>
      <Textarea
        placeholder={placeholder}
        className={classes.textArea}
        value={value}
        onChange={handleChangeValue}
        disabled={disabled}
        style={{ display: 'block', height: '100%' }}
      />
      <Stack direction="row" justifyContent="flex-end" spacing={2.5}>
        <CloseButton onClick={onClose}>PERUUTA</CloseButton>
        {!disabled && (
          <SaveButton onClick={handleAcceptValue}>
            {t('#portal.task.todo.form.button.label.save')}
          </SaveButton>
        )}
      </Stack>
    </Stack>
  );
};

export default ExpandedForm;
